import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Switch, Route, Redirect } from 'react-router-dom'

import withStore from 'with/Store'

import Nav from 'components/Nav'
import Modal from 'components/Modal'
import Button from 'components/buttons/Button'

import Login from 'pages/Login'
import ForgotPassword from 'pages/ForgotPassword'
import ResetPassword from 'pages/ResetPassword'

import Dashboard from 'pages/Dashboard'
import Employees from 'pages/Employees'
import Timesheets from 'pages/Timesheets'
import Timesheet from 'pages/Timesheet'
import Reports from 'pages/Reports'
import Settings from 'pages/Settings'

import { isLoggedIn } from 'utils/auth'
import ProtectedRoute from 'utils/ProtectedRoute'
import { Roles } from 'api/UsersAPI'

import styles from './App.css'

@withRouter
@withStore(
  state => state.app
)
class App extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  renderLoggedIn() {
    return (
      <Fragment>
        <Nav />
        <Switch>
          <Route path='/dashboard' component={Dashboard} />
          <ProtectedRoute allowedRoles={[Roles.Manager, Roles.Admin]} path='/users' component={Employees} />
          <Route exact path='/timesheets' component={Timesheets} />
          <Route path='/timesheets/:id' component={Timesheet} />
          <Route path='/reports' component={Reports} />
          <ProtectedRoute allowedRoles={[Roles.Admin]} path='/settings' component={Settings} />

          <Redirect to='/dashboard' />
        </Switch>
      </Fragment>
    )
  }

  renderLoggedOut() {
    return (
      <Fragment>
        <Switch>
          <Route path='/login' component={Login} />
          <Route path='/forgotPassword' component={ForgotPassword} />
          <Route path='/resetPassword/:token' component={ResetPassword} />

          <Redirect to='/login' />
        </Switch>
      </Fragment>
    )
  }

  render() {
    const content = isLoggedIn() ? this.renderLoggedIn() : this.renderLoggedOut()

    return (
      <div className={styles.App}>

        <Modal open={!!this.props.error} zIndex={20}>
          <h1>Ooops</h1>
          <p style={{fontSize: '1.6rem'}}>
            {this.props.error}
          </p>
          <br/>
          <Button 
            color='orange' 
            onClick={() => {
              this.props.dispatch({ type: 'HIDE_ERROR', payload: null })
            }}>
            OK 
          </Button>
        </Modal>

        {content}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js